import { Link } from 'gatsby'
import React, { FunctionComponent } from 'react'
import { Icon } from 'react-icons-kit'
import { arrowLeft2 as leftArrowIcon } from 'react-icons-kit/icomoon/arrowLeft2'

interface PreviousPageLinkProps {
  url: string
  label: string
}

export const PreviousPageLink: FunctionComponent<PreviousPageLinkProps> = ({
  url,
  label,
}) => (
  <a
    href={url}
    style={{
      fontWeight: 500,
    }}
    data-testid="previous-page-link"
  >
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '1rem',
      }}
    >
      <Icon
        icon={leftArrowIcon}
        style={{
          color: '#001435',
          paddingRight: '5px',
          lineHeight: '18px',
        }}
      />
      {label}
    </span>
  </a>
)
